import { render, staticRenderFns } from "./many_distribute.vue?vue&type=template&id=4095d2d8&scoped=true&"
import script from "./many_distribute.vue?vue&type=script&lang=js&"
export * from "./many_distribute.vue?vue&type=script&lang=js&"
import style0 from "./many_distribute.vue?vue&type=style&index=0&id=4095d2d8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4095d2d8",
  null
  
)

export default component.exports